import { render, staticRenderFns } from "./Tortvocabulary.vue?vue&type=template&id=19d1dbbd&scoped=true"
import script from "./Tortvocabulary.vue?vue&type=script&lang=js"
export * from "./Tortvocabulary.vue?vue&type=script&lang=js"
import style0 from "./Tortvocabulary.vue?vue&type=style&index=0&id=19d1dbbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d1dbbd",
  null
  
)

export default component.exports